import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Country } from '@app/models/country';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  constructor(private httpClient: HttpClient) {
  }

  getCountries() {
    return this.httpClient
      .get<any>(`${environment.apiEndPoint}countries/read`)
      .pipe(
        map(res => res ? res.document.records as Country[] : []),
        catchError(this.handleError)
      );
  }

  getCountryById(id) {
    return this.httpClient
      .post<any>(`${environment.apiEndPoint}country/read_one`, JSON.stringify({ id: `${id}` }))
      .pipe(
        map(res => res.document as Country),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if(error?.error?.data) retour += '<br />'+error?.error?.data;
    return Promise.reject(retour);
  }
}